
export interface IJobListState {
    [key: string]: any;
    job_definition?: string;
    data_type?: string;
    qty?: number;
    skill?: string;
    requested_by?: string;
    job_type?: string;
    product_id?: string;
    product_details?: string;
    location?: string;
    level?: number;
    contact_person?: string;
    deadline?: string; // You might want to use a Date type here
    assigned_to?: string | null; // If assigned_to can be a string or null
    id?: number;
    CreatedAt?: string; // You might want to use a Date type here
}

export enum IJobListActionTypes {
    FETCH_JOB_LIST_DETAILS_REQUEST = 'FETCH_JOB_LIST_DETAILS_LIST_REQUEST',
    FETCH_JOB_LIST_DETAILS_SUCCESS = 'FETCH_JOB_LIST_DETAILS_SUCCESS',
    FETCH_JOB_LIST_DETAILS_FAILURE = 'FETCH_JOB_LIST_DETAILS_FAILURE',
}


export type IJobListActionCreator = {
    type: string;
    payload: IJobListState;
};


